import React, { useEffect, useState } from "react";
import useI18n from "../hooks/useI18n.js";
import {
  HMSNotificationTypes,
  useHMSNotifications,
} from "@100mslive/react-sdk";
import { Dialog, Text } from "@100mslive/roomkit-react";

export function PermissionErrorModal() {
  const notification = useHMSNotifications(HMSNotificationTypes.ERROR);
  const [deviceType, setDeviceType] = useState("");
  const [isSystemError, setIsSystemError] = useState(false);
  const { t } = useI18n("common");
  useEffect(() => {
    if (
      !notification ||
      (notification.data?.code !== 3001 && notification.data?.code !== 3011) ||
      (notification.data?.code === 3001 &&
        notification.data?.message.includes("screen"))
    ) {
      return;
    }
    console.error(`[${notification.type}]`, notification);
    const errorMessage = notification.data?.message;
    const hasAudio = errorMessage.includes("audio");
    const hasVideo = errorMessage.includes("video");
    const hasScreen = errorMessage.includes("screen");
    if (hasAudio && hasVideo) {
      setDeviceType(t("camera_and_microphone"));
    } else if (hasAudio) {
      setDeviceType(t("microphone"));
    } else if (hasVideo) {
      setDeviceType(t("camera"));
    } else if (hasScreen) {
      setDeviceType(t("screenshare"));
    }
    setIsSystemError(notification.data.code === 3011);
  }, [notification, t]);
  return deviceType ? (
    <Dialog.Root
      open
      onOpenChange={value => {
        if (!value) {
          setDeviceType("");
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content css={{ w: "min(480px, 90%)" }}>
          <Dialog.Title
            css={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid $border_default",
              pb: "$8",
            }}
          >
            <Text css={{ fontWeight: "$semiBold" }}>
              {t("x_permissions_blocked", { deviceType })}
            </Text>
            <Dialog.DefaultClose
              data-testid="dialoge_cross_icon"
              css={{ alignSelf: "start" }}
            />
          </Dialog.Title>
          <Text variant="md" css={{ py: "$10" }}>
            {t("access_to_x_required", { deviceType })}
            &nbsp;
            {isSystemError
              ? t("enable_permissions_x_system", { deviceType })
              : t("enable_permissions_x_addrbar", { deviceType })}
          </Text>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  ) : null;
}
